export const calculateSOTR = (
  rate: number | null,
  treasuryRate: number | null
): number | null => {
  if (rate === null || treasuryRate === null) {
    return null
  }
  return rate - treasuryRate
}
